import * as React from 'react';
import { BackButton } from '../../components/buttons/back-button';
import './installer-guides.scss';

export const InstallerGuidesView: React.FunctionComponent = () => {
  const installerGuides = [
    {
      site: 'Optimised Retrofit',
      url: 'https://www.optimised-retrofit.wales/downloads/or/',
    },
    {
      site: 'Eastern High / Aspen Grove',
      url: 'https://www.optimised-retrofit.wales/downloads/easternhigh/',
    },
    {
      site: 'Penderi',
      url: 'https://www.optimised-retrofit.wales/downloads/penderi/',
    },
  ];

  return (
    <div>
      <BackButton />
      <h1>Installation Guides</h1>

      <div className="installation-guides">
        {installerGuides.map(installerGuide => (
          <a
            key={installerGuide.site}
            className="btn btn-outline btn-large btn-full installation-guides__link"
            href={installerGuide.url}
            data-qa={`installer-guide-${installerGuide.site}`}
          >
            {installerGuide.site}
          </a>
        ))}
      </div>
    </div>
  );
};
